import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import ActionDelete from "material-ui/svg-icons/action/delete";
import {translate} from "admin-on-rest";

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;

const BulkDeleteButton = ({
  basePath = "",
  label = "aor.action.delete",
  record = {},
  translate
}) => {
  if (record && record.ids) {
    record.ids.forEach((id, index) => {
      record.id_nb = index + 1;
    });
  }

  if (record.id_nb) {
    if (record.id_nb === 1) {
      return (
        <FlatButton
          secondary
          label={label && translate(label)}
          icon={<ActionDelete />}
          containerElement={
            <Link to={`${linkToRecord(basePath, record.ids[0])}/delete`} />
          }
          hoverColor="transparent"
          fullWidth
          style={{overflow: "inherit", textAlign: "left"}}
        />
      );
    } else {
      return (
        <FlatButton
          secondary
          label={label && translate(label)}
          icon={<ActionDelete />}
          containerElement={
            <Link
              to={{
                pathname: "/bulkdelete",
                props: {
                  record
                }
              }}
            />
          }
          hoverColor="transparent"
          fullWidth
          style={{overflow: "inherit", textAlign: "left"}}
        />
      );
    }
  } else {
    return (
      <FlatButton
        secondary
        label={label && translate(label)}
        icon={<ActionDelete />}
        hoverColor="transparent"
        fullWidth
        disabled={true}
        style={{overflow: "inherit", textAlign: "left"}}
      />
    );
  }
};

BulkDeleteButton.propTypes = {
  basePath: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  translate: PropTypes.func.isRequired
};

export default translate(BulkDeleteButton);



// WEBPACK FOOTER //
// ./src/components/CRM/BulkDeleteButton.js